<template>
    <div class="checkbox" :class="[{ checked : value }, { disabled }, { inline }, { invalid: error }]">
        <label :for="id">
            <input type="checkbox"
                   ref="checkbox"
                   :checked="!!value"
                   :name="id"
                   :id="id"
                   :value="value"
                   :disabled="disabled"
                   @change="update" />
            <span class="square">
                <span class="glyphicon glyphicon-ok"></span>
            </span>
            <slot></slot>
        </label>
    </div>
</template>

<script>
    export default {
        name: 'Checkbox',
        props: {
            id: String,
            disabled: Boolean,
            value: Boolean,
            inline: Boolean,
            error: {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            this.$emit('input', this.value);
        },
        methods: {
            update({ target }) {
               this.$emit('input', target.checked);
               this.$emit('change', target.checked);
            }
        }
    };
</script>
